var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TagCore, } from '@core-front/tag';
import Fittext from '@telia-front/fittext';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import Tooltip from '@telia-front/tooltip';
const tagSizeFontSize = {
    tiny: 'small',
    small: 'large',
    medium: 'extra-large',
    large: 'small',
    icon: undefined,
};
const Tag = (props) => {
    const { purpose } = props, rest = __rest(props, ["purpose"]);
    const getSize = () => {
        if (props.size !== 'icon') {
            return props.size;
        }
    };
    const BEM = () => {
        const classArray = [`telia-tag--${props.purpose}`];
        if (props.size === 'icon') {
            classArray.push('telia-tag--icon');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(TagCore, Object.assign({}, rest, { size: getSize(), className: BEM(), components: {
            Icon,
            Tooltip,
            Image,
            Fittext,
        }, tagSizeFontSizeProp: tagSizeFontSize })));
};
export { Tag as default, };
